import cx from 'clsx';
import { trackEvent } from '@kcd/event-tracker';

import PlacementRenderer from '~/domains/mmp/components/PlacementRenderer';
import { usePlacementBanners } from '~/domains/mmp/queries';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';
import type { OAISchema } from '~/types/openapi';
import { openModal } from '~/utils/mobileApp';

import type { Variant } from '../utils';
import { getBannerStyles } from '../utils';

interface Props {
  data: OAISchema['PlacementBannerResponse'];
}

const MarketCardBannerContent = ({ data }: Props) => {
  const { variant, content, buttonText, landingUrl, imageUrl } = data;

  const onClick = () => {
    trackEvent('clicked banner in 마켓/홈', {
      placementName: '홈/카드배너',
    });

    if (landingUrl) {
      openModal({ url: landingUrl });
    }
  };

  return (
    <div
      className={cx(
        'flex items-center gap-8 px-16 py-16 rounded-16 justify-between',
        getBannerStyles(variant as unknown as Variant).banner,
      )}
      role="presentation"
      onClick={onClick}
    >
      <div className="flex items-center gap-12 truncate">
        {imageUrl && (
          <span className="size-32 shrink-0">
            <img className="size-32" src={imageUrl} alt="" />
          </span>
        )}
        <span
          className={cx(
            'typo-title100-semibold overflow-hidden text-ellipsis whitespace-nowrap',
            getBannerStyles(variant as unknown as Variant).title,
          )}
        >
          {content}
        </span>
      </div>
      <span
        className={cx(
          'flex-shrink-0 flex items-center px-12 py-[5px] typo-paragraph100-semibold rounded-12',
          getBannerStyles(variant as unknown as Variant).button,
        )}
      >
        {buttonText}
      </span>
    </div>
  );
};

const MarketCardBanner = () => {
  const { businessId } = useBusinessIdStore();
  const { data } = usePlacementBanners(
    businessId,
    'market_card_banner_with_floating',
  );

  if (!data || !data.length) return <></>;

  return (
    <PlacementRenderer {...data[0]}>
      <MarketCardBannerContent data={data[0]} />
    </PlacementRenderer>
  );
};

export default MarketCardBanner;
